import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { UtilityBar } from './UtilityBar';
import { Header } from './Header';
import { Footer } from './Footer';

// On a page change: back to the top, and focus moves to the page's h1 so
// screen-reader users hear the new page title. Skipped on first load.
function RouteEffects() {
  const { pathname } = useLocation();
  const last = useRef(pathname);
  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    window.scrollTo(0, 0);
    document.querySelector<HTMLElement>('main h1')?.focus({ preventScroll: true });
  }, [pathname]);
  return null;
}

export function Layout() {
  return (
    <div className="bg-paper">
      <a
        href="#main"
        onClick={(e) => {
          e.preventDefault();
          document.getElementById('main')?.focus();
        }}
        className="absolute top-2 -left-[9999px] z-50 bg-navy-900 px-4 py-2.5 text-white focus:left-2"
      >
        Skip to content
      </a>
      <RouteEffects />
      <UtilityBar />
      <Header />
      <main id="main" tabIndex={-1} className="outline-none">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
